module.exports = __webpack_public_path__ + "img/webinar-quiz.fa12a01d.svg";